/* ============================================================================
   Cart drawer CRO — one-click upsell "Add" buttons (cart-upsell-row.liquid).
   Event delegation on document so handlers survive the drawer's AJAX innerHTML
   swaps. Add → bundle re-rendered cart-drawer + cart-bubble sections in the
   same response (Section Rendering API) → swap → drawer stays open. Mirrors
   the pattern in product.js renderContents() / hardware-incentive.js.
   ============================================================================ */
(function () {
  // Loaded by cart-drawer.liquid and again by sho-required-notice.liquid on the
  // cart page; bind once or every click would add twice.
  if (window.__cdCartCro) return;
  window.__cdCartCro = true;

  function swapSections(sections) {
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && sections['cart-drawer']) {
      var fresh = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('.cart-drawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        if (typeof drawer.removeProductEvent === 'function') {
          drawer.removeProductEvent();
        }
      }
    }
    if (sections['cart-bubble']) {
      var freshCount = new DOMParser()
        .parseFromString(sections['cart-bubble'], 'text/html')
        .querySelector('.thb-item-count');
      var count = document.querySelector('#cart-drawer-toggle .thb-item-count');
      if (count && freshCount) {
        count.innerHTML = freshCount.innerHTML;
      }
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  document.addEventListener('click', function (e) {
    // [data-sho-guard-add] = CDXMT-106 "add Sho to check out" buttons (sho-required-notice).
    var btn = e.target.closest ? e.target.closest('.cart-upsell-add, [data-sho-guard-add]') : null;
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    var isShoGuard = btn.hasAttribute('data-sho-guard-add');

    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty }],
        sections: 'cart-drawer,cart-bubble'
      })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (t) {
            throw new Error('Upsell add failed [' + r.status + ']: ' + t);
          });
        }
        return r.json();
      })
      .then(function (data) {
        // The cart page renders its own lines and checkout button outside the
        // drawer, so reload it to clear the Sho check there.
        if (isShoGuard && document.getElementById('cart-form')) {
          window.location.reload();
          return;
        }
        if (data && data.sections) {
          swapSections(data.sections);
        }
      })
      .catch(function (err) {
        console.error('[cart-upsell] add failed:', err);
        btn.removeAttribute('aria-busy');
      });
  });
})();
